import { columns, writeAccessorKeys } from './constants'
import { GetPlayerListTableData } from '@/modules/manage-player/type'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import useQueryProfile from '@/modules/auth/api/hooks/useQueryProfile'
import { useMemo } from 'react'
import { DataTableFilterSelector } from '@/common/ui/table/data-table-filter-selector'
import useQueryGetRankName from '@/modules/manage-rank/api/hooks/useQueryGetRankName'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import { DataTableArrow } from '@/common/ui/table/data-table-arrow'
import PlayerSearchControls from '@/common/components/PlayerSearchControls'

interface GetPlayerListTableProps {
	data: GetPlayerListTableData[]
	total: number
	isLoading?: boolean
	onSort?: (columnId: string, order: 'asc' | 'desc' | undefined) => void
}

export default function GetPlayerListTable({
	data,
	total,
	isLoading,
	onSort,
}: GetPlayerListTableProps) {
	const { data: user } = useQueryProfile()
	const { data: ranks } = useQueryGetRankName()
	const { setRankFilter, setBannedFilter } = useTablePagination()
	const hasWritePermission = user?.userGroup.writePermission.includes(
		PermissionKeys.MANAGE_PLAYER,
	)

	const filteredColumns = useMemo(
		() =>
			columns.filter(
				(column) =>
					hasWritePermission ||
					('accessorKey' in column &&
						!writeAccessorKeys.includes(column.accessorKey)),
			),
		[hasWritePermission],
	)

	const rankOptions = useMemo(
		() =>
			ranks?.map((rank) => ({
				label: rank.name,
				value: rank.id,
			})) || [],
		[ranks],
	)

	const bannedOptions = [
		{ label: 'ถูกแบน', value: 'true' },
		{ label: 'ไม่ถูกแบน', value: 'false' },
	]

	return (
		<div className="space-y-4">
			<PlayerSearchControls
				additionalFilters={
					<>
						<DataTableFilterSelector
							options={rankOptions}
							placeholder="เลือกแรงค์"
							label="แรงค์"
							onValueChange={setRankFilter}
						/>
						<DataTableFilterSelector
							options={bannedOptions}
							placeholder="สถานะการแบน"
							label="สถานะการแบน"
							onValueChange={setBannedFilter}
						/>
					</>
				}
			/>
			<DataTableArrow
				columns={filteredColumns}
				data={data}
				total={total}
				isLoading={isLoading}
				onSort={onSort}
			/>
		</div>
	)
}
